export default "__VITE_ASSET__122de001__"